<!--
Displays navbar for each screen.
(Rewritten for Vue 3 by cm359n)
Usage: <Footer active="text" />
@author ab557z
-->
<template>
    <div class="footer">
      <ul class="nav nav-tabs footerOv">
        <li :class="{ footerItem: true, menuActive: isMenuItem(footerItem) }" v-for="(footerItem, index) in footerMenu" v-bind:key="index" v-on:click="handleClick(footerItem)">
          <span :class="{ itemActive: itemSelected[index] }" :style="{color: isMenuItem(footerItem) ? '#fff !important' : '#005C8A'}">
            <font-awesome-icon class="footerImg" :icon="isMenuItem(footerItem) && active == 'menu' ? 'fa-solid fa-x' : footerItem.icon" size="lg"></font-awesome-icon><br/>{{ isMenuItem(footerItem) && active == 'menu' ? 'Close' : footerItem.title }}
          </span>
        </li>
        <li class="fallbackItem" v-if="fallbackUsed">An error has occurred. Please log out via the More menu and log back in.</li>
      </ul>
    </div>
</template>

<script setup>
import * as lst from '@/components/localStorage.js'
import { ref, defineProps, onMounted } from 'vue'
import { useRouter } from 'vue-router'

const router = useRouter()

// converted from Options API (Vue 2) to Composition API (Vue 3) using this guide:
// https://vuejs.org/api/composition-api-setup.html#basic-usage

// this is an example and we PROBABLY want to get the codebase, in trunk, over to Vue3
// before we start converting components over en masse

const props = defineProps({
  active: String
})

/* used to be 'data ()' */
const itemSelected = ref([]) // why is this a hash in the original code???
const fallbackUsed = ref(false)
const hasRoomBookingAccess = ref(lst.getValue('hasRoomBookingAccess') === 'true')
// const unreadNotif = ref(lst.getValue('unreadNotifications'))
const footerMenu = ref([{
  'title': 'More',
  'icon': 'ellipsis-h',
  'path': '/menu'
}]) // failsafe

onMounted(() => {
  let footerMenuText = lst.getValue('footerMenu')
  if (typeof footerMenuText !== 'undefined') {
    let fobj // = undefined
    try {
      fobj = JSON.parse(footerMenuText)
    } catch (e) {
      // fall through to failsafe
    }
    if (typeof fobj != 'undefined' && fobj != null) {
      footerMenu.value = JSON.parse(footerMenuText)
      fallbackUsed.value = false
    } else {
      // try fetching it again and storing the cookie yourself?
      // this.fetchFooterMenu()
      console.log('error: footer menu not found - using failsafe')
      fallbackUsed.value = true
    }
  }

  const lookups = {
    'index': '/',
    'library': '/library/0',
    'voting': '/voting/login',
    'help': '/support/incident',
    'wellbeing': '/wellbeing/main',
    'locations': '/buildingto'
    /* the following are usually in the 'more' menu, at least as of Sep 2021 */
  }
  itemSelected.value = []

  // and a fallback lookup.
  // e.g. if active is specified as "events" we will look through the footer menu for the item that goes to '/events'
  let selectedUrl = lookups[props.active]
  if (typeof selectedUrl === 'undefined') {
    selectedUrl = '/' + props.active
  }
  let matched = false
  if (typeof selectedUrl !== 'undefined') {
    let ctr = 0
    for (let item of footerMenu.value) {
      if (item.path == selectedUrl) {
        itemSelected.value[ctr] = true
        matched = true
        console.log('active item ' + props.active + ' matches item #' + ctr + ' -> ' + item.path)
      }
      ctr++
    }
  }
  if (!matched) {
    const lastitem = footerMenu.value.length - 1
    console.log('no active item, or no match. item on right (index #' + lastitem + ') will be highlighted')
    itemSelected.value[lastitem] = true
  }

  // disable booking in the event this user doesn't have access
  if (!hasRoomBookingAccess.value) {
    let bel = document.getElementById('bookingLi')
    if (bel != null) {
      bel.classList.add('disabled')
    }
  }
})

function handleClick (footerItem) {
  if (isMenuItem(footerItem) && props.active == 'menu') {
    go('/')
  } else {
    go(footerItem.path)
  }
}
function isMenuItem (footerItem) {
  return footerItem.title == 'Menu'
}

function go (path) {
  router.push(path).catch((err) => {
    const errstr = err.toString()
    if (!errstr.startsWith('NavigationDuplicated')) {
      // NavigationDuplicated: user clicked on the highlighted icon which is the current screen so ignore
      console.log(err)
    }
  })
}

</script>
<style>

.footerItem span:hover {
color:#951272;
}

.fallbackItem {
  width: 80%;
  font-size: 14px;
  font-weight: 700;
  color:#003865;
}
.footerItem {
  width:20%;
  text-align:center;
  font-size:12px; /* 14px specified by craig but too big? */
  justify-content: center;
  align-items: center;
  display: flex;
  height: 60px;
}

.count-notif{
  vertical-align:middle;
  margin-left:-5px;
  font-size:13px;
}
.footerOv {
  width:100%;
  height: 100%;
}

li.footerItem.disabled {
  opacity: 0.5;
  pointer-events:none;
}

.footer {
  position: fixed;
  bottom: 0;
  max-width:inherit;
  width:100%;
  height: auto;
  /*line-height: 48px;*/ /* Vertically center the text there */
  line-height:17px; /* craig says 24px but tc trying 19px */
  background: #ffffff;
  z-index:1001;
  box-shadow: 7px 0 7.18px hsla(240,4%,46%,.54);
  /* notch height on iOS 11.0 */
  padding-bottom: constant(safe-area-inset-bottom);
  /* notch height on iOS 11+ */
  padding-bottom: env(safe-area-inset-bottom);
}

.nav-tabs {
  border-bottom: none !important;
}

.footerItem .itemActive{
  color:#951272 !important;
}

.footerItem svg {
  width: 20px;
  height: 20px;
}

.menuActive {
  background-color: #003865;
}

</style>
